import { defineComponent as _defineComponent } from 'vue';
import BRegister from './BRegister.vue';
import BForgotPassword from './BForgotPassword.vue';
import BIcon from '@/components/general/BIcon.vue';
import BLogin from '@/components/general/Auth/BLogin.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'BAuth',
  emits: ['close'],
  setup: function setup(__props, _ref) {
    var emit = _ref.emit;
    var whitelabelLite = useWhitelabelLite();
    var currentScreen = ref('login');
    function close() {
      emit('close');
    }
    function gotoRegister() {
      currentScreen.value = 'register';
    }
    function gotoLogin() {
      currentScreen.value = 'login';
    }
    function gotoForgot() {
      currentScreen.value = 'forgot';
    }
    function logomarkUrl() {
      var _whitelabelLite$logom;
      return (_whitelabelLite$logom = whitelabelLite === null || whitelabelLite === void 0 ? void 0 : whitelabelLite.logomarkUrl) !== null && _whitelabelLite$logom !== void 0 ? _whitelabelLite$logom : require('assets/img/logo_primary.svg');
    }
    return {
      __sfc: true,
      emit: emit,
      whitelabelLite: whitelabelLite,
      currentScreen: currentScreen,
      close: close,
      gotoRegister: gotoRegister,
      gotoLogin: gotoLogin,
      gotoForgot: gotoForgot,
      logomarkUrl: logomarkUrl,
      BRegister: BRegister,
      BForgotPassword: BForgotPassword,
      BIcon: BIcon,
      BLogin: BLogin
    };
  }
});